import { ColumnConfig } from 'generated/graphql';
import { SearchColumnsVisibility } from 'stores/interfaces/SearchColumnsState';

export const getSearchColumnVisibility = (columnConfig: ColumnConfig): SearchColumnsVisibility => {
  const keys: Array<keyof SearchColumnsVisibility> = [
    'id',
    'deadline',
    'status',
    'translation',
    'source',
    'issue',
    'language',
    'xtmProjectName',
    'filename',
    'submitterGroupName',
    'projectName',
    'projectManager',
    'qualityExpert',
    'qmContact',
    'substitutePm',
    'assignee',
    'creator',
    'queryCreatedAt',
    'loio',
    'repository',
    'collection',
    'stringId',
    'queryTrackerId',
    'account',
    'applicationComponent',
    'sourceContact'
  ];

  const result = keys.reduce((acc, key) => {
    acc[key] = columnConfig[key] || false;
    return acc;
  }, {} as SearchColumnsVisibility);

  return result;
};
